import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_2,
  OPERATOR_TYPES_3,
  OPERATOR_TYPES_4,
  OPERATOR_TYPES_6,
  OPERATOR_TYPES_EXTENSION,
} from './operators';

const EXTENSION_CONDITION = {
  key: 'extension',
  name: 'EXTENSION',
  inputType: 'plain_text',
  filterOperators: OPERATOR_TYPES_EXTENSION,
};

// Computed when the rule is checked; a delayed status wait checks them only when it is due
// (AutomationRules::ComputedConditions).
const WORKING_HOURS_CONDITION = {
  key: 'working_hours',
  name: 'WORKING_HOURS',
  inputType: 'search_select',
  filterOperators: OPERATOR_TYPES_1,
};

const AGENT_REPLIED_CONDITION = {
  key: 'agent_replied',
  name: 'AGENT_REPLIED',
  inputType: 'search_select',
  filterOperators: OPERATOR_TYPES_1,
};

export const AUTOMATIONS = {
  message_created: {
    conditions: [
      EXTENSION_CONDITION,
      {
        key: 'message_type',
        name: 'MESSAGE_TYPE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'content',
        name: 'MESSAGE_CONTAINS',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email_auto_reply',
        name: 'EMAIL_AUTO_REPLY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'marketplace_country',
        name: 'MARKETPLACE_COUNTRY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'channel_type',
        name: 'CHANNEL_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'message_source_type',
        name: 'MESSAGE_SOURCE_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'ai_prompt',
        name: 'AI_FILTER',
        inputType: 'plain_text',
        filterOperators: [
          {
            value: 'equal_to',
            label: 'Equal to',
          },
        ],
      },
      {
        key: 'call_direction',
        name: 'CALL_DIRECTION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'missed_call',
        name: 'MISSED_CALL',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'incoming_messages_count',
        name: 'INCOMING_MESSAGE_COUNT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
      {
        key: 'outgoing_messages_count',
        name: 'OUTGOING_MESSAGE_COUNT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
      {
        key: 'email_recipients',
        name: 'EMAIL_RECIPIENTS',
        inputType: 'plain_text',
        filterOperators: [
          {
            value: 'contains',
            label: 'Contains',
          },
          {
            value: 'does_not_contain',
            label: 'Does not contain',
          },
        ],
      },
      {
        key: 'attachment_extension',
        name: 'ATTACHMENT_EXTENSION',
        inputType: 'comma_separated_plain_text',
        filterOperators: [
          {
            value: 'contains',
            label: 'Contains',
          },
        ],
      },
      {
        key: 'labels',
        name: 'LABEL',
        inputType: 'multi_select',
        filterOperators: [
          {
            value: 'contains',
            label: 'Contains',
          },
          {
            value: 'does_not_contain',
            label: 'Does not contain',
          },
        ],
      },
      WORKING_HOURS_CONDITION,
      AGENT_REPLIED_CONDITION,
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'add_note',
        name: 'ADD_NOTE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_transcript_with_details',
        name: 'SEND_EMAIL_TRANSCRIPT_WITH_DETAILS',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },

      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'change_priority',
        name: 'CHANGE_PRIORITY',
      },
      {
        key: 'add_sla',
        name: 'ADD_SLA',
      },
      {
        key: 'skip_auto_priority',
        name: 'SKIP_AUTO_PRIORITY',
      },
      {
        key: 'skip_auto_labeling',
        name: 'SKIP_AUTO_LABELING',
      },
      {
        key: 'auto_translate',
        name: 'AUTO_TRANSLATE',
      },
      {
        key: 'move_conversation_to_inbox',
        name: 'MOVE_CONVERSATION_TO_INBOX',
      },
      {
        key: 'send_message_in_new_conversation',
        name: 'SEND_MESSAGE_IN_NEW_CONVERSATION',
      },
      {
        key: 'send_sms_in_new_conversation',
        name: 'SEND_SMS_IN_NEW_CONVERSATION',
      },
      {
        key: 'stop_processing_rules',
        name: 'STOP_PROCESSING_RULES',
      },
    ],
  },
  conversation_created: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'marketplace_country',
        name: 'MARKETPLACE_COUNTRY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'channel_type',
        name: 'CHANNEL_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'message_source_type',
        name: 'MESSAGE_SOURCE_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'labels',
        name: 'LABEL',
        inputType: 'multi_select',
        filterOperators: [
          {
            value: 'contains',
            label: 'Contains',
          },
          {
            value: 'does_not_contain',
            label: 'Does not contain',
          },
        ],
      },
      WORKING_HOURS_CONDITION,
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'add_note',
        name: 'ADD_NOTE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_transcript_with_details',
        name: 'SEND_EMAIL_TRANSCRIPT_WITH_DETAILS',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'change_priority',
        name: 'CHANGE_PRIORITY',
      },
      {
        key: 'add_sla',
        name: 'ADD_SLA',
      },
      {
        key: 'auto_translate_conversation',
        name: 'AUTO_TRANSLATE_CONVERSATION',
      },
      {
        key: 'move_conversation_to_inbox',
        name: 'MOVE_CONVERSATION_TO_INBOX',
      },
      {
        key: 'send_message_in_new_conversation',
        name: 'SEND_MESSAGE_IN_NEW_CONVERSATION',
      },
      {
        key: 'send_sms_in_new_conversation',
        name: 'SEND_SMS_IN_NEW_CONVERSATION',
      },
      {
        key: 'stop_processing_rules',
        name: 'STOP_PROCESSING_RULES',
      },
    ],
  },
  conversation_updated: {
    conditions: [
      {
        key: 'status',
        name: 'STATUS',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'marketplace_country',
        name: 'MARKETPLACE_COUNTRY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'channel_type',
        name: 'CHANNEL_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'message_source_type',
        name: 'MESSAGE_SOURCE_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'call_direction',
        name: 'CALL_DIRECTION',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'missed_call',
        name: 'MISSED_CALL',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'missed_call_count',
        name: 'MISSED_CALL_COUNT',
        inputType: 'plain_text',
        filterOperators: [
          {
            value: 'equal_to',
            label: 'Equal to',
          },
          {
            value: 'not_equal_to',
            label: 'Not equal to',
          },
          {
            value: 'is_greater_than',
            label: 'Is greater than',
          },
          {
            value: 'is_less_than',
            label: 'Is less than',
          },
        ],
      },
      {
        key: 'labels',
        name: 'LABEL',
        inputType: 'multi_select',
        filterOperators: [
          {
            value: 'contains',
            label: 'Contains',
          },
          {
            value: 'does_not_contain',
            label: 'Does not contain',
          },
        ],
      },
      WORKING_HOURS_CONDITION,
      AGENT_REPLIED_CONDITION,
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'add_note',
        name: 'ADD_NOTE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_transcript_with_details',
        name: 'SEND_EMAIL_TRANSCRIPT_WITH_DETAILS',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'change_priority',
        name: 'CHANGE_PRIORITY',
      },
      {
        key: 'add_sla',
        name: 'ADD_SLA',
      },
      {
        key: 'auto_translate_conversation',
        name: 'AUTO_TRANSLATE_CONVERSATION',
      },
      {
        key: 'move_conversation_to_inbox',
        name: 'MOVE_CONVERSATION_TO_INBOX',
      },
      {
        key: 'send_message_in_new_conversation',
        name: 'SEND_MESSAGE_IN_NEW_CONVERSATION',
      },
      {
        key: 'send_sms_in_new_conversation',
        name: 'SEND_SMS_IN_NEW_CONVERSATION',
      },
      {
        key: 'stop_processing_rules',
        name: 'STOP_PROCESSING_RULES',
      },
    ],
  },
  conversation_opened: {
    conditions: [
      {
        key: 'browser_language',
        name: 'BROWSER_LANGUAGE',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'email',
        name: 'EMAIL',
        inputType: 'comma_separated_plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'mail_subject',
        name: 'MAIL_SUBJECT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'country_code',
        name: 'COUNTRY_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'marketplace_country',
        name: 'MARKETPLACE_COUNTRY',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'referer',
        name: 'REFERER_LINK',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_2,
      },
      {
        key: 'assignee_id',
        name: 'ASSIGNEE_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'phone_number',
        name: 'PHONE_NUMBER',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_6,
      },
      {
        key: 'team_id',
        name: 'TEAM_NAME',
        inputType: 'search_select',
        filterOperators: OPERATOR_TYPES_3,
      },
      {
        key: 'inbox_id',
        name: 'INBOX',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'channel_type',
        name: 'CHANNEL_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'message_source_type',
        name: 'MESSAGE_SOURCE_TYPE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'conversation_language',
        name: 'CONVERSATION_LANGUAGE',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'priority',
        name: 'PRIORITY',
        inputType: 'multi_select',
        filterOperators: OPERATOR_TYPES_1,
      },
      {
        key: 'incoming_messages_count',
        name: 'INCOMING_MESSAGE_COUNT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
      {
        key: 'outgoing_messages_count',
        name: 'OUTGOING_MESSAGE_COUNT',
        inputType: 'plain_text',
        filterOperators: OPERATOR_TYPES_4,
      },
      {
        key: 'labels',
        name: 'LABEL',
        inputType: 'multi_select',
        filterOperators: [
          {
            value: 'contains',
            label: 'Contains',
          },
          {
            value: 'does_not_contain',
            label: 'Does not contain',
          },
        ],
      },
      WORKING_HOURS_CONDITION,
      AGENT_REPLIED_CONDITION,
    ],
    actions: [
      {
        key: 'assign_agent',
        name: 'ASSIGN_AGENT',
      },
      {
        key: 'assign_team',
        name: 'ASSIGN_TEAM',
      },
      {
        key: 'add_label',
        name: 'ADD_LABEL',
      },
      {
        key: 'remove_label',
        name: 'REMOVE_LABEL',
      },
      {
        key: 'send_email_to_team',
        name: 'SEND_EMAIL_TO_TEAM',
      },
      {
        key: 'send_message',
        name: 'SEND_MESSAGE',
      },
      {
        key: 'add_note',
        name: 'ADD_NOTE',
      },
      {
        key: 'send_email_transcript',
        name: 'SEND_EMAIL_TRANSCRIPT',
      },
      {
        key: 'send_email_transcript_with_details',
        name: 'SEND_EMAIL_TRANSCRIPT_WITH_DETAILS',
      },
      {
        key: 'mute_conversation',
        name: 'MUTE_CONVERSATION',
      },
      {
        key: 'snooze_conversation',
        name: 'SNOOZE_CONVERSATION',
      },
      {
        key: 'resolve_conversation',
        name: 'RESOLVE_CONVERSATION',
      },
      {
        key: 'open_conversation',
        name: 'OPEN_CONVERSATION',
      },
      {
        key: 'send_webhook_event',
        name: 'SEND_WEBHOOK_EVENT',
      },
      {
        key: 'send_attachment',
        name: 'SEND_ATTACHMENT',
      },
      {
        key: 'change_priority',
        name: 'CHANGE_PRIORITY',
      },
      {
        key: 'add_sla',
        name: 'ADD_SLA',
      },
      {
        key: 'auto_translate_conversation',
        name: 'AUTO_TRANSLATE_CONVERSATION',
      },
      {
        key: 'move_conversation_to_inbox',
        name: 'MOVE_CONVERSATION_TO_INBOX',
      },
      {
        key: 'send_message_in_new_conversation',
        name: 'SEND_MESSAGE_IN_NEW_CONVERSATION',
      },
      {
        key: 'send_sms_in_new_conversation',
        name: 'SEND_SMS_IN_NEW_CONVERSATION',
      },
      {
        key: 'stop_processing_rules',
        name: 'STOP_PROCESSING_RULES',
      },
    ],
  },
};

// A finished call fires for the conversation of the call, so the rule takes the conditions and actions of
// conversation_updated; the missed calls are counted with the call data (PhoneCalls::MissedCallsCountService). Not "Send a
// Message": it replies in the call itself, which reaches the caller only as an SMS (with an SMS inbox for the
// number, ContinueOnSmsService); the editor offers "Send Message in New Conversation" (email) and "Send SMS in New
// Conversation" (from a chosen SMS inbox) instead. A rule with "Send a Message" can still be saved through the API,
// and the editor keeps showing it.
AUTOMATIONS.phone_call_finished = {
  conditions: AUTOMATIONS.conversation_updated.conditions,
  actions: AUTOMATIONS.conversation_updated.actions.filter(
    ({ key }) => key !== 'send_message'
  ),
};

// A resolved conversation fires conversation_updated too, so the rule offers the same conditions and
// actions. Not the status condition: the status is always resolved here.
AUTOMATIONS.conversation_resolved = {
  conditions: AUTOMATIONS.conversation_updated.conditions.filter(
    ({ key }) => key !== 'status'
  ),
  actions: AUTOMATIONS.conversation_updated.actions,
};

export const AUTOMATION_RULE_EVENTS = [
  {
    key: 'conversation_created',
    value: 'CONVERSATION_CREATED',
  },
  {
    key: 'conversation_updated',
    value: 'CONVERSATION_UPDATED',
  },
  {
    key: 'message_created',
    value: 'MESSAGE_CREATED',
  },
  {
    key: 'conversation_opened',
    value: 'CONVERSATION_OPENED',
  },
  {
    key: 'conversation_resolved',
    value: 'CONVERSATION_RESOLVED',
  },
  {
    key: 'phone_call_finished',
    value: 'PHONE_CALL_FINISHED',
  },
];

export const AUTOMATION_ACTION_TYPES = [
  {
    key: 'assign_agent',
    label: 'ASSIGN_AGENT',
    inputType: 'search_select',
  },
  {
    key: 'assign_team',
    label: 'ASSIGN_TEAM',
    inputType: 'search_select',
  },
  {
    key: 'add_label',
    label: 'ADD_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'remove_label',
    label: 'REMOVE_LABEL',
    inputType: 'multi_select',
  },
  {
    key: 'send_email_to_team',
    label: 'SEND_EMAIL_TO_TEAM',
    inputType: 'team_message',
  },
  {
    key: 'send_email_transcript',
    label: 'SEND_EMAIL_TRANSCRIPT',
    inputType: 'email',
  },
  {
    key: 'send_email_transcript_with_details',
    label: 'SEND_EMAIL_TRANSCRIPT_WITH_DETAILS',
    inputType: 'email',
  },
  {
    key: 'mute_conversation',
    label: 'MUTE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'snooze_conversation',
    label: 'SNOOZE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'resolve_conversation',
    label: 'RESOLVE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'open_conversation',
    label: 'OPEN_CONVERSATION',
    inputType: null,
  },
  {
    key: 'send_webhook_event',
    label: 'SEND_WEBHOOK_EVENT',
    inputType: 'url',
  },
  {
    key: 'send_attachment',
    label: 'SEND_ATTACHMENT',
    inputType: 'attachment',
  },
  {
    key: 'send_message',
    label: 'SEND_MESSAGE',
    inputType: 'html_textarea',
  },
  {
    key: 'add_note',
    label: 'ADD_NOTE',
    inputType: 'textarea',
  },
  {
    key: 'change_priority',
    label: 'CHANGE_PRIORITY',
    inputType: 'search_select',
  },
  {
    key: 'add_sla',
    label: 'ADD_SLA',
    inputType: 'search_select',
  },
  {
    key: 'auto_translate',
    label: 'AUTO_TRANSLATE',
    inputType: null,
  },
  {
    key: 'auto_translate_conversation',
    label: 'AUTO_TRANSLATE_CONVERSATION',
    inputType: null,
  },
  {
    key: 'skip_auto_priority',
    label: 'SKIP_AUTO_PRIORITY',
    inputType: null,
  },
  {
    key: 'skip_auto_labeling',
    label: 'SKIP_AUTO_LABELING',
    inputType: null,
  },
  {
    key: 'move_conversation_to_inbox',
    label: 'MOVE_CONVERSATION_TO_INBOX',
    inputType: 'search_select',
  },
  {
    key: 'send_message_in_new_conversation',
    label: 'SEND_MESSAGE_IN_NEW_CONVERSATION',
    inputType: 'inbox_message',
  },
  {
    key: 'send_sms_in_new_conversation',
    label: 'SEND_SMS_IN_NEW_CONVERSATION',
    inputType: 'sms_message',
  },
  {
    key: 'stop_processing_rules',
    label: 'STOP_PROCESSING_RULES',
    inputType: null,
  },
];
